export function csvToBlob(csv: string) {
  return new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });
}
